import { inject } from '@angular/core';
import {delay, Observable, of} from 'rxjs';
import { Logger } from 'src/app/core/interfaces/Logger';
import { accountMocks } from 'src/app/core/mocks/accounts.mock';
import { Account } from '../../domain/model/account.model';
import { IAccountApiRepository } from '../../domain/repositories/account-api.repository';
import { AccountEntityMapper } from '../mappers/account-entity.mapper';
import { Entry } from '../../../entry/domain/model/entry.model';
import { ISaveAccountEntriesRequest } from '../../application/builders/save-account-entries-request.builder';

export class AccountApiMockAdapter implements IAccountApiRepository {
  private readonly logger = inject(Logger);
  private readonly simulatedDelay = Math.random() * 1000 + 500;

  getAll(): Observable<Account[]> {
    this.logger.debug('[AccountApiMockAdapter#getAll] Returning mock accounts');

    const accounts = accountMocks.map(AccountEntityMapper.fromStorage);

    return of(accounts).pipe(delay(this.simulatedDelay));
  }

  update(account: Partial<Account>): Observable<boolean> {
    this.logger.debug('[AccountApiMockAdapter#update] Simulated update', account);

    return of(true).pipe(delay(this.simulatedDelay));
  }

  getById(accountId: string): Observable<Account | null>{
    this.logger.debug('[AccountApiMockAdapter#getById] Simulated get by ID', accountId);

    const account = accountMocks.find(acc => acc._id === accountId);

    if (!account) {
      this.logger.debug('[AccountApiMockAdapter#getById] Account not found', accountId);

      return of(null).pipe(delay(this.simulatedDelay));
    }

    return of(AccountEntityMapper.fromStorage(account)).pipe(delay(this.simulatedDelay));
  }

  getEntriesByAccountIds(accountIds: string[]): Observable<Entry[]> {
    this.logger.debug('[AccountApiMockAdapter#getEntriesByAccountIds] Simulated get entries by account IDs', accountIds);

    return of([]).pipe(delay(this.simulatedDelay));
  }

  saveEntries(request: ISaveAccountEntriesRequest): Observable<void> {
    this.logger.debug('[AccountApiMockAdapter#saveEntries] Simulated save entries', request);

    return of(undefined).pipe(delay(this.simulatedDelay));
  }

  removeAllEntriesFromAccount(entriesId: string[]): Observable<void> {
    this.logger.debug('[AccountApiMockAdapter#removeAllEntriesFromAccount] Simulated remove all entries from account', entriesId);

    return of(undefined).pipe(delay(this.simulatedDelay));
  }
}
